<template>
  <div class="node-card">
    <div class="card-cms-header">
      <span class="card-title">{{ node.namaKlasifikasi }}</span>
      <div class="card-actions">
        <a-button type="text" size="small" class="edit-btn" @click="$emit('edit', node)">
          <edit-outlined />
        </a-button>
        <a-button type="text" size="small" class="delete-btn" @click="handleDelete">
          <delete-outlined />
        </a-button>
      </div>
    </div>
    <div v-if="node.opsiKlasifikasi && node.opsiKlasifikasi.length > 0" class="card-options">
      <span v-for="opsi in node.opsiKlasifikasi" :key="opsi" class="opsi-badge">
        {{ opsi }}
      </span>
    </div>
    <div v-if="node.ditandaiTerakhir" class="card-tags">
      <a-tag color="orange" size="small">Terakhir</a-tag>
    </div>
    <div v-if="node.algoritmaTerkaitId" class="card-tags">
      <a-tag color="blue" size="small"
        >Terkait: {{ getAlgoritmaName(node.algoritmaTerkaitId) }}</a-tag
      >
    </div>
    <div v-if="node.kalkulatorTerkaitId" class="card-tags">
      <a-tag color="green" size="small"
        >Kalkulator: {{ getKalkulatorName(node.kalkulatorTerkaitId) }}</a-tag
      >
    </div>
  </div>
</template>

<script>
import { EditOutlined, DeleteOutlined } from '@ant-design/icons-vue'

export default {
  name: 'NodeCard',
  components: { EditOutlined, DeleteOutlined },
  props: {
    node: {
      type: Object,
      required: true,
    },
    algoritmaList: {
      type: Array,
      default: () => [],
    },
    kalkulatorList: {
      type: Array,
      default: () => [],
    },
  },
  emits: ['edit', 'delete'],
  setup(props, { emit }) {
    const getAlgoritmaName = id => {
      const alg = props.algoritmaList.find(a => a.id === id)
      return alg?.nama || 'Unknown'
    }

    const getKalkulatorName = id => {
      const k = props.kalkulatorList.find(k => k.id === id)
      return k?.title || 'Unknown'
    }

    const handleDelete = () => {
      emit('delete', props.node)
    }

    return {
      getAlgoritmaName,
      getKalkulatorName,
      handleDelete,
    }
  },
}
</script>

<style scoped>
.node-card {
  background: #fff;
  border: 1px solid var(--Mobile-Secondary, #2f318b);
  border-radius: 16px;
  padding: 12px 16px;
  min-width: 200px;
  width: fit-content;
}

.card-cms-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 8px;
  width: 100%;
}

.card-title {
  font-size: 14px;
  font-weight: 600;
  color: #1f2937;
}

.card-actions {
  display: flex;
  gap: 4px;
}

.edit-btn,
.delete-btn {
  color: #6b7280 !important;
  padding: 2px 4px !important;
  height: auto !important;
}

.edit-btn:hover {
  color: #8b5cf6 !important;
}

.delete-btn:hover {
  color: #ef4444 !important;
}

.card-options {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
}

.opsi-badge {
  border-radius: 16px;
  background: var(--Mobile-Secondary, #2f318b);
  color: var(--Neutral-0, #f9fafb);
  font-family: Lato, sans-serif;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 22px;
  padding: 4px 12px;
}

.card-tags {
  margin-top: 8px;
  display: flex;
  gap: 4px;
}
</style>
